import { createContext, useEffect, useState, ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isSiteAccessGateEnabled } from '../config/siteAccess';
import { defaultSettings } from '../settings/settings';
import { prefetchDefensiveTemplates } from '../utils/templateCache';

const siteAccessGateEnabled = isSiteAccessGateEnabled();

interface AppContextProps {
  isAuthenticated: boolean;
  login: (password: string) => void;
}

export const AppContext = createContext<AppContextProps | undefined>(undefined);

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    if (!siteAccessGateEnabled) {
      return true;
    }
    return !!localStorage.getItem('token');
  });

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!siteAccessGateEnabled) {
      if (location.pathname === '/login') {
        navigate('/');
      }
      return;
    }
    if (!isAuthenticated && location.pathname !== '/login') {
      navigate('/login');
    }
  }, [isAuthenticated, location, navigate]);

  useEffect(() => {
    void prefetchDefensiveTemplates();
  }, []);

  const login = (password: string) => {
    if (!siteAccessGateEnabled) {
      navigate('/');
      return;
    }
    if (password === defaultSettings.robotsFTW) {
      localStorage.setItem('token', password);
      setIsAuthenticated(true);
      navigate('/'); // Redirect to a protected route after login
    } else {
      console.log('No go!');
      navigate('/login');
    }
  };

  return <AppContext.Provider value={{ isAuthenticated, login }}>{children}</AppContext.Provider>;
};
